import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Terms of delivery', 'Description'];

export const TermsOfDeliveryDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: termsOfDeliveryOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /termsOfDelivery',
    labelAttribute: 'description',
    valueAttribute: 'termsOfDelivery',
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={termsOfDeliveryOptions} columnNames={COLUMN_NAMES} />;
};
